// src/pages/AccountCreatePage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";


function AccountCreateLeadWebStyle() {
    return (
        <style>{`
            .account-create-pro{color:#f5fbff}
            .account-create-pro select option{background:#061a2f;color:white}
            .account-create-pro .crm-hero{background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%);border:1px solid rgba(11,93,140,.8);box-shadow:0 20px 45px rgba(0,0,0,.28)}
            .account-create-pro .crm-card{border:1px solid rgba(11,93,140,.82);background:#04192b;box-shadow:0 12px 30px rgba(0,0,0,.24)}
            .account-create-pro .crm-card-head{background:#031425;border-bottom:1px solid #0b4d78}
            .account-create-pro .crm-actions-bar{background:#031425;border:1px solid #0b4d78;border-radius:22px}
            .account-create-pro .crm-btn{border:1px solid #24537a;background:#0b2740;color:#f5fbff;border-radius:999px;padding:10px 14px;font-size:12px;font-weight:700}
            .account-create-pro .crm-btn:hover{background:#10324f;border-color:#d4af37}
            .account-create-pro .crm-btn-primary{background:#d4af37;color:#081a2b;border-color:#d4af37}
            .account-create-pro .crm-btn-primary:hover{background:#e8c457}
            .account-create-pro .crm-input{width:100%;border:1px solid #0b5f91;border-radius:.85rem;padding:.65rem .75rem;font-size:12px;outline:none;background:#0b2740;color:#fff}
            .account-create-pro .crm-input::placeholder{color:#7ea8c7}
            .account-create-pro .crm-input:focus{border-color:#d4af37;box-shadow:0 0 0 2px rgba(212,175,55,.18)}
            .account-create-pro .crm-label{display:block;font-size:11px;color:#8fb9da;margin-bottom:6px;font-weight:700;text-transform:uppercase;letter-spacing:.14em}
            .account-create-pro table{border-collapse:separate;border-spacing:0;background:#061a2f}
            .account-create-pro table tbody tr{transition:background .18s ease, box-shadow .18s ease;background:#08233d!important}
            .account-create-pro table tbody tr:nth-child(even){background:#092a49!important}
            .account-create-pro table tbody tr:hover{background:rgba(56,189,248,.075)!important;box-shadow:inset 3px 0 0 #d4af37}
            .account-create-pro table tbody td{border-top:1px solid #24587c;background:transparent!important;color:#f5fbff}
            .account-create-pro table thead th{position:sticky;top:0;z-index:10;background:#061a2f!important;color:#8fb9da;border-bottom:1px solid #24587c;text-transform:uppercase;letter-spacing:.13em}
            .account-create-pro .crm-scroll{overflow:auto;max-height:70vh}
            .account-create-pro .crm-scroll-top{overflow-x:auto;overflow-y:hidden;height:14px;border:1px solid #24587c;border-radius:999px;background:#061a2f;margin:0 12px 8px 12px}
            .account-create-pro .crm-scroll-spacer{height:1px;min-width:1100px}
            .account-create-pro .crm-scroll::-webkit-scrollbar,.account-create-pro .crm-scroll-top::-webkit-scrollbar{height:10px;width:10px}
            .account-create-pro .crm-scroll::-webkit-scrollbar-track,.account-create-pro .crm-scroll-top::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .account-create-pro .crm-scroll::-webkit-scrollbar-thumb,.account-create-pro .crm-scroll-top::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .account-create-pro .crm-scroll::-webkit-scrollbar-thumb:hover,.account-create-pro .crm-scroll-top::-webkit-scrollbar-thumb:hover{background:#d4af37}
            .account-create-pro .grid-row-main{font-weight:700;color:#fff!important}
            .account-create-pro .grid-row-sub{color:#9fc4df!important;font-size:12px}
            .account-create-pro .crm-badge{display:inline-flex;align-items:center;border-radius:999px;border:1px solid #24537a;background:#0f2d48;color:#d9e8f5;padding:4px 9px;font-size:10px;font-weight:700}
            .account-create-pro .crm-modal-panel{background:#04192b;border:1px solid #0b5f91;color:#fff;box-shadow:0 20px 60px rgba(0,0,0,.35)}
            .account-create-pro .crm-modal-head{background:#031425;border-bottom:1px solid #0b4d78}
        `}</style>
    );
}

const AccountCreatePage = () => {
    const navigate = useNavigate();
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const [form, setForm] = useState({
        name: "",
        alias: "",
        sector: "",
        city: "",
        state: "",
        country: "",
        website: "",
        phone: "",
        email: "",
        notes: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!form.name.trim()) {
            setError("El nombre de la cuenta es obligatorio.");
            return;
        }

        try {
            setSaving(true);

            const res = await fetch("${API_BASE}/account_create.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok || data.success === false) {
                throw new Error(data.error || "No se pudo crear la cuenta.");
            }

            alert("Cuenta creada correctamente.");
            // Puedes redirigir a cuentas o al detalle, según lo que te regrese el API
            // Si tu API regresa el ID, podríamos hacer navigate(`/accounts/${data.id}`)
            navigate("/accounts");
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al crear la cuenta.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <MainLayout>
            <AccountCreateLeadWebStyle />
            <div className="account-create-pro min-h-screen bg-[#041426] px-3 py-6 md:px-6 md:py-8"><div className="mx-auto max-w-[1500px] space-y-6">
                <div className="crm-hero rounded-[28px] px-6 py-6 md:px-7 md:py-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                        <button
                            type="button"
                            onClick={() => navigate("/accounts")}
                            className="text-[11px] text-[#8fd8ff] hover:underline mb-1"
                        >
                            ← Volver a cuentas
                        </button>
                        <h2 className="text-3xl md:text-4xl font-black tracking-tight text-white">
                            Nueva cuenta
                        </h2>
                        <p className="text-xs md:text-sm text-[#9fc4df]">
                            Registra una nueva empresa para gestión de oportunidades y
                            proyectos.
                        </p>
                    </div>
                </div>

                {error && (
                    <div className="mb-2 text-xs text-[#fca5a5] bg-[#2b1117] border border-[#ef4444]/40 rounded-lg px-3 py-2">
                        {error}
                    </div>
                )}

                <form
                    onSubmit={handleSubmit}
                    className="crm-card rounded-[24px] p-5 space-y-4 text-xs"
                >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div>
                            <label className="crm-label">
                                Nombre de la cuenta *
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                className="crm-input"
                                required
                            />
                        </div>

                        <div>
                            <label className="crm-label">
                                Alias
                            </label>
                            <input
                                type="text"
                                name="alias"
                                value={form.alias}
                                onChange={handleChange}
                                className="crm-input"
                            />
                        </div>

                        <div>
                            <label className="crm-label">
                                Sector
                            </label>
                            <input
                                type="text"
                                name="sector"
                                value={form.sector}
                                onChange={handleChange}
                                className="crm-input"
                            />
                        </div>

                        <div>
                            <label className="crm-label">
                                Sitio web
                            </label>
                            <input
                                type="text"
                                name="website"
                                value={form.website}
                                onChange={handleChange}
                                className="crm-input"
                            />
                        </div>

                        <div>
                            <label className="crm-label">
                                Ciudad
                            </label>
                            <input
                                type="text"
                                name="city"
                                value={form.city}
                                onChange={handleChange}
                                className="crm-input"
                            />
                        </div>

                        <div>
                            <label className="crm-label">
                                Estado
                            </label>
                            <input
                                type="text"
                                name="state"
                                value={form.state}
                                onChange={handleChange}
                                className="crm-input"
                            />
                        </div>

                        <div>
                            <label className="crm-label">
                                País
                            </label>
                            <input
                                type="text"
                                name="country"
                                value={form.country}
                                onChange={handleChange}
                                className="crm-input"
                            />
                        </div>

                        <div>
                            <label className="crm-label">
                                Teléfono
                            </label>
                            <input
                                type="text"
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                className="crm-input"
                            />
                        </div>

                        <div>
                            <label className="crm-label">
                                Correo
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                className="crm-input"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="crm-label">
                            Notas
                        </label>
                        <textarea
                            name="notes"
                            value={form.notes}
                            onChange={handleChange}
                            rows={3}
                            className="crm-input resize-none"
                        />
                    </div>

                    <div className="flex justify-end gap-2 pt-2">
                        <button
                            type="button"
                            onClick={() => navigate("/accounts")}
                            className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-[#d9e8f5] text-xs hover:bg-[#10324f]"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={saving}
                            className="crm-btn crm-btn-primary disabled:opacity-60"
                        >
                            {saving ? "Guardando..." : "Crear cuenta"}
                        </button>
                    </div>
                </form>
            </div>
            </div>
        </MainLayout>
    );
};

export default AccountCreatePage;

